import { ISite, ISiteV2 } from "../interfaces/Site";

export const isSiteV2 = (site: ISite | ISiteV2): site is ISiteV2 => {
    return site.usesSiteModules === true;
};
